import React from "react";

import Edit from "./Edit";
import Screen from "../Screen";
import Overview from "./Overview";
import { Auth } from "../../../../context/admin/Authentication";
import { StaticProvider } from "../../../../context/static/StaticContext";

export const Privacy = () => {
  return (
    <StaticProvider>
      <Auth
        children={
          <Screen
            component={<Overview />}
            title="Privacy Policy"
          />
        }
      />
    </StaticProvider>
  );
};

export const EditPrivacy = () => {
  return (
    <StaticProvider>
      <Auth
        children={
          <Screen
            component={<Edit />}
            title="Edit Privacy Policy"
          />
        }
      />
    </StaticProvider>
  );
};
